import { Currency } from '../model'
import { useStickyPreferredCurrency } from './useStickyPreferredCurrency'

export function useCurrencySelect() {
  const [first, second, setInternalCurrencies, swap] = useStickyPreferredCurrency()

  function setCurrencies(first: Currency, second: Currency) {
    setInternalCurrencies(first, second)
  }

  return {
    first,
    second,
    setCurrencies,
    swap,
  }
}
